/*
 * Pufien — hızlı ekleme yardımcısı (P10, 8 Ekim 2026). layout/theme.liquid yükler (hızlı ekleme açıkken, her sayfada).
 *
 * 1) Horizon'un quick-add bileşeni ürün sayfası adresini yalnız <product-card> içinden okuyor. Kart dışında
 *    (sepet çekmecesi önerisi, "Kışlık takımı tamamla", "Benzer ürünler") adres boş kalıyor ve pencere boş açılıyordu.
 *    Adres boşsa en yakın [data-pf-urun-url] kapsayıcısından alınır. Temanın quick-add.js dosyası değiştirilmez.
 * 2) [data-pf-hizli-ekle] bağlantısı aynı kapsayıcıdaki <quick-add-component>'in penceresini açar: beden/renk orada
 *    seçilir, sayfadan çıkılmaz. Bileşen ya da pencere yoksa (ya da sayfa alınamazsa) bağlantı ürün sayfasına gider.
 */
(function () {
  if (window.__pfHizliEkle) return;
  window.__pfHizliEkle = true;

  function adres(el) {
    var k = el && el.closest ? el.closest('[data-pf-urun-url]') : null;
    return k ? new URL(k.getAttribute('data-pf-urun-url'), location.origin).toString() : '';
  }

  customElements.whenDefined('quick-add-component').then(function () {
    var C = customElements.get('quick-add-component');
    if (!C || C.prototype.__pfAdres) return;
    var d = Object.getOwnPropertyDescriptor(C.prototype, 'productPageUrl');
    if (!d || !d.get) return;
    Object.defineProperty(C.prototype, 'productPageUrl', {
      configurable: true,
      get: function () { return d.get.call(this) || adres(this); }
    });
    C.prototype.__pfAdres = true;
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-pf-hizli-ekle]') : null;
    if (!btn) return;
    var kap = btn.closest('[data-pf-urun-url]');
    var qa = kap ? kap.querySelector('quick-add-component') : null;
    var C = customElements.get('quick-add-component');
    if (!qa || !C || !C.prototype.__pfAdres || typeof qa.handleClick !== 'function' || !document.getElementById('quick-add-dialog')) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    Promise.resolve()
      .then(function () { return qa.handleClick(e); })
      .catch(function () { location.href = btn.getAttribute('href') || adres(btn); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });
})();
